import axios from "axios";
import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import { FaRegFilePdf } from "react-icons/fa";
import { FaRegFileExcel } from "react-icons/fa";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { RiFileExcel2Line } from "react-icons/ri";
import BsaModal from "./BsaModal";

function AssetGateway({ id, refreshRender }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [openBsa, setOpenBsa] = useState(false);
  const [detailId, setDetailId] = useState("");
  const [bankName, setBankName] = useState("");
  const [image, setImage] = useState(null);

  const checkForNoData = (data) => {
    let state = false;
    Object.keys(data).forEach((key) => {
      if (data[key].length > 0) {
        state = true;
      }
    });
    return state;
  };
  const handleExcelDownload = async (assetName, recordArray) => {
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/download_as_excel`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          asset_name: assetName,
          record_ids: recordArray,
        },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.url.status) {
        const url = res.data.url.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleExcelDownload2 = async (recordItem) => {
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/bank_analysis?bank_detail_id=${recordItem}&data_required=all&download=true`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.url.status) {
        const url = res.data.url.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const formatRepository = (repository, key) => {
    if (key !== "mutual_funds" && key !== "stocks") return repository;
    if (repository === "ZERODHA BROKING LIMITED") return "Zerodha";
    if (repository === "NEXTBILLION TECHNOLOGY PRIVATE LIMITED") return "Groww";
    return repository;
  };
  function formatString(str) {
    if (str === "mf_central") return "MF Central";
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }
  const fetchAssetGateway = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/asset_gateway`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.asset_gateway) {
        let state = checkForNoData(res.data.asset_gateway);
        if (!state) setNoData(true);
        setData(res.data.asset_gateway);
      } else {
        setNoData(true);
      }
      setLoading(false);
    } catch (error) {}
  };
  useEffect(() => {
    fetchAssetGateway();
  }, [refreshRender]);
  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <div className=" mt-4 w-full overflow-auto max-h-[calc(100vh-190px)] bg-white rounded-lg py-4">
          <div className="flex justify-between text-sm font-semibold px-4">
            <p className="w-[22%]">Asset Classes</p>
            <p className="w-[15%]">Provider</p>
            <p className="w-[15%]">Consent Period</p>
            <p className="w-[15%]">Last fetched date</p>
            <p className="w-[15%] text-right">Download</p>
          </div>
          {Object.keys(data).map((key) => {
            if (data[key].length === 0) return null;
            return data[key].map((data, index) => {
              return (
                <>
                  {index === 0 && (
                    <p className=" text-xs font-semibold mt-6 mb-2 px-4">
                      {formatString(key)}
                    </p>
                  )}
                  <div className="flex justify-between text-xs font-medium h-[32px] items-center hover:bg-[#e6ebed] px-4">
                    <p className="w-[22%] flex items-center">
                      {data.url !== null && (
                        <img
                          src={data.url}
                          alt=""
                          width={22}
                          height={21}
                          className=" mr-[10px] object-contain"
                        />
                      )}
                      {formatRepository(data.repository, key) || "---"}
                      <span className="p-2 text-xs">
                        {data.account_number
                          ? "(" + data.account_number.slice(8) + ")"
                          : "---"}
                      </span>
                    </p>
                    <p className="w-[15%]">
                      {/* {key==="mutual_funds" || key==="stocks"?} */}
                      {formatString(data.provider) || "---"}
                    </p>
                    <p className="w-[15%]">{data.consented_period || "---"}</p>
                    <p className="w-[15%]">{data.last_fetched_date || "---"}</p>
                    <p className="w-[15%] text-right">
                      {" "}
                      <button
                        className={`p-[2px] border-2 border-[#00394d] rounded mr-6 inline-flex items-center ${
                          (data.record_ids.length === 0 ||
                            key === "real_estates") &&
                          "border-[#c6c6c6]"
                        } `}
                        disabled={
                          data.record_ids.length === 0 || key === "real_estates"
                        }
                        title="Transactions"
                        onClick={() => {
                          handleExcelDownload(key, data.record_ids);
                        }}
                      >
                        <FaRegFileExcel
                          style={{
                            width: 16,
                            height: 16,
                            color: `${
                              data.record_ids.length === 0 ||
                              key === "real_estates"
                                ? "#c6c6c6"
                                : "#00394d"
                            }`,
                            fontWeight: 500,
                          }}
                        />
                      </button>
                      {/* {key === "bank" && (
                        <button
                          className="p-[3px] border-2 border-[#00394d] rounded"
                          title="Bank Statement Analyzer"
                          onClick={() => {
                            setDetailId(data.record_ids[0]);
                            setImage(data.url);
                            setBankName(data.repository);
                            setOpenBsa(true);
                          }}
                        >
                          <RiFileExcel2Line
                            style={{
                              width: 16,
                              height: 16,
                              color: "#00394d",
                              fontWeight: 600,
                            }}
                          />
                        </button>
                      )} */}
                    </p>
                  </div>
                </>
              );
            });
          })}
        </div>
      )}

      {openBsa && (
        <BsaModal
          setOpenBsa={setOpenBsa}
          detailId={detailId}
          bankName={bankName}
          image={image}
        />
      )}
    </>
  );
}

export default AssetGateway;
